// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cloud-servers-network__item{margin-bottom:60px}.cloud-servers-network__icon{margin-bottom:24px;width:auto;max-height:72px}@media (max-width:991px){.cloud-servers-network__icon{max-height:64px}}@media (max-width:575px){.cloud-servers-network__icon{max-height:48px}}", ""]);
// Exports
module.exports = exports;
